import chapter1ru from'./chapter1ru';

const plotRu = [
  ...chapter1ru
];

export default plotRu;
